import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ESkeletonType } from '@norfolk-southern/accessns-components';

import { NSCommons } from '@ruby/configs/common.constants';
import { NSUnitTrainDialogsConstants } from '@ruby/configs/unit-train-dialogs.constants';
import { IUTEventVessel } from '@ruby/modules/unit-train/models/unit-train-permit.interface';

@Component({
  selector: 'ng-vessel-event-dialog',
  styleUrls: ['./vessel-event.dialog.scss'],
  templateUrl: './vessel-event.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VesselEventDialog implements OnChanges {
  @Input() event?: IUTEventVessel;
  @Input() loading!: boolean;
  gridConfigurations = NSUnitTrainDialogsConstants.vesselEventNomineeGridConfigs;
  skeleton: ESkeletonType = ESkeletonType.WIDGET;
  form = new UntypedFormGroup({
    dock: new UntypedFormControl({ value: undefined, disabled: true }),
    vessel: new UntypedFormControl({ value: undefined, disabled: true }),
    contractLoadDate: new UntypedFormControl({ value: undefined, disabled: true }),
    comments: new UntypedFormControl({ value: undefined, disabled: true }),
    status: new UntypedFormControl({ value: undefined, disabled: true })
  });

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.event?.currentValue && this.event) {
      this.setupFormData(this.event);
    }
  }

  private setupFormData(event: IUTEventVessel): void {
    this.form.controls.dock.setValue(event.dockDesc);
    this.form.controls.vessel.setValue(event.vesselDesc);
    this.form.controls.contractLoadDate.setValue(NSCommons.formatNSDate(event.contractLoadDate, 'MM/dd/yyyy'));
    this.form.controls.comments.setValue(event.comments);
  }
}
